import { COLOUR } from "./constants";

export const APPOINTMENT_TYPES = {
  MOBILE: "mobile",
  FIXED: "fixed",
};

export const APPOINTMENT_STATUS_NAMES = {
  confirmed: "Confirmed",
  pending: "Pending",
  cancelled: "Cancelled",
  completed: "Completed",
};

export const APPOINTMENT_STATUS = [
  {
    id: "confirmed",
    name: APPOINTMENT_STATUS_NAMES.confirmed,
    colour: COLOUR.BLUE,
  },
  {
    id: "pending",
    name: APPOINTMENT_STATUS_NAMES.pending,
    colour: COLOUR.YELLOW,
  },
  {
    id: "cancelled",
    name: APPOINTMENT_STATUS_NAMES.cancelled,
    colour: COLOUR.RED,
  },
  {
    id: "completed",
    name: APPOINTMENT_STATUS_NAMES.completed,
    colour: COLOUR.GREEN,
  },
];
